import React from 'react';
import { Layout } from '../../components/Layout';
import { Checklist } from '../../components/Checklist';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { LINUX_CHECKLIST } from '../../utils/constants';
import { Server, ShieldCheck, Lock, ArrowRight, AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Linux() {
  return <Layout data-id="element-1974">
      <div className="container mx-auto px-4 py-12" data-id="element-1975">
        <div className="mb-12" data-id="element-1976">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-cyan-500/10 text-cyan-400 text-xs font-medium mb-4 border border-cyan-500/20" data-id="element-1977">
            <Server className="h-3 w-3 mr-2" data-id="element-1978" />
            Device Library
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-100 mb-4" data-id="element-1979">
            Linux Security Protocol
          </h1>
          <p className="text-xl text-slate-400 max-w-3xl" data-id="element-1980">
            Standar pengamanan Linux untuk desktop & server.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1981">
          <div className="lg:col-span-2 space-y-12" data-id="element-1982">
            <section data-id="element-1983">
              <h2 className="text-2xl font-bold text-slate-100 mb-6 flex items-center" data-id="element-1984">
                <ShieldCheck className="h-6 w-6 text-cyan-500 mr-3" data-id="element-1985" />
                Baseline Security (Wajib)
              </h2>
              <div className="space-y-4" data-id="element-1986">
                <Card className="p-5 border-l-4 border-l-cyan-500" data-id="element-1987">
                  <h3 className="font-bold text-slate-100 mb-1" data-id="element-1988">
                    Full Disk Encryption (LUKS)
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-1989">
                    Wajib saat instalasi. Melindungi data fisik jika drive
                    dicuri.
                  </p>
                </Card>
                <Card className="p-5 border-l-4 border-l-cyan-500" data-id="element-1990">
                  <h3 className="font-bold text-slate-100 mb-1" data-id="element-1991">
                    SSH Hardening
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-1992">
                    Disable root login. Disable password auth (gunakan SSH Key).
                    Ganti port default (opsional).
                  </p>
                </Card>
                <Card className="p-5 border-l-4 border-l-cyan-500" data-id="element-1993">
                  <h3 className="font-bold text-slate-100 mb-1" data-id="element-1994">
                    Firewall (UFW/IPTables)
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-1995">
                    Deny incoming by default. Allow hanya port yang diperlukan
                    (misal 22, 80, 443).
                  </p>
                </Card>
              </div>
            </section>

            <section data-id="element-1996">
              <h2 className="text-2xl font-bold text-slate-100 mb-6 flex items-center" data-id="element-1997">
                <Lock className="h-6 w-6 text-cyan-500 mr-3" data-id="element-1998" />
                Advanced Protection
              </h2>
              <ul className="space-y-4 list-disc list-inside text-slate-300" data-id="element-1999">
                <li data-id="element-2000">
                  <strong className="text-slate-100" data-id="element-2001">Fail2Ban:</strong> Install
                  untuk memblokir IP yang melakukan brute-force attack.
                </li>
                <li data-id="element-2002">
                  <strong className="text-slate-100" data-id="element-2003">
                    Unattended Upgrades:
                  </strong>{' '}
                  Konfigurasi update keamanan otomatis.
                </li>
                <li data-id="element-2004">
                  <strong className="text-slate-100" data-id="element-2005">
                    Minimal Service Exposure:
                  </strong>{' '}
                  Matikan service yang tidak dipakai (systemctl disable).
                </li>
              </ul>
            </section>

            <section className="border-t border-slate-800 pt-8" data-id="element-2006">
              <h2 className="text-xl font-bold text-slate-100 mb-4 text-red-400" data-id="element-2007">
                Common Mistakes
              </h2>
              <ul className="space-y-3 text-slate-400" data-id="element-2008">
                <li className="flex items-start" data-id="element-2009">
                  <AlertTriangle className="h-5 w-5 text-red-500/50 mr-3 flex-shrink-0 mt-0.5" data-id="element-2010" />
                  <span data-id="element-2011">Login sebagai root untuk aktivitas sehari-hari.</span>
                </li>
                <li className="flex items-start" data-id="element-2012">
                  <AlertTriangle className="h-5 w-5 text-red-500/50 mr-3 flex-shrink-0 mt-0.5" data-id="element-2013" />
                  <span data-id="element-2014">
                    Membiarkan port database (3306, 5432) terbuka ke publik
                    internet.
                  </span>
                </li>
              </ul>
            </section>
          </div>

          <div className="space-y-6" data-id="element-2015">
            <Checklist id="linux-checklist" title="Linux Checklist" items={LINUX_CHECKLIST} data-id="element-2016" />
            <Card className="p-6 bg-slate-900/50 border-slate-800" data-id="element-2017">
              <h3 className="font-bold text-slate-100 mb-4" data-id="element-2018">Next Steps</h3>
              <div className="space-y-3" data-id="element-2019">
                <Link to="/org/protect" data-id="element-2020">
                  <Button variant="secondary" fullWidth className="justify-between group" data-id="element-2021">
                    Org Protocol
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-2022" />
                  </Button>
                </Link>
                <Link to="/tools" data-id="element-2023">
                  <Button variant="secondary" fullWidth className="justify-between group" data-id="element-2024">
                    Security Tools
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-2025" />
                  </Button>
                </Link>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </Layout>;
}